import React from "react";
import MyNavbar from "../../../components/general/navbar/MyNavbar";
import HeroSection from "../../../subscreens/customer/home/herosection/HeroSection";
import Categories from "../../../subscreens/customer/home/categories/Categories";
// import WhyUs from "../../../subscreens/customer/home/whyUs/WhyUs"
import AboutUs from "../../../subscreens/customer/home/aboutus/AboutUs";
import NewArrivals from "../../../subscreens/customer/home/newArrivals/NewArrivals";
import SellerSection from "../../../subscreens/customer/business/SellerSection";
import ScrollBanner from "../../../subscreens/customer/home/scrollBanner/ScrollBanner";
// import PromoCards from "../../../subscreens/customer/home/promoCards/promoCards";
import VideoSection from "../../../subscreens/customer/home/videoSection/VideoSection";
import Testimonials from "../../../subscreens/customer/home/testimonials/Testimonials";
import BlogSection from "../../../subscreens/customer/home/blogSection/BlogSection";
import Footer from "../../../components/general/footer/Footer";
const Home = () => {
  return (
    <>
      <MyNavbar />
      <HeroSection />

      <Categories />

      <AboutUs />

      <NewArrivals />
      <SellerSection />

      <ScrollBanner />

      <VideoSection />

      <Testimonials />
      <BlogSection />
      <Footer />
    </>
  );
};

export default Home;
